'use strict';

// Get URLs and other primary data
var getUserData = require('./models/user-urls');
var getMarketplaceData = require('./models/marketplace-urls');
var getManageData = require('./models/manage-urls');

// Get Links
var getManageLinks = require('./views/links/manage-links');
var getMarketplaceLinks = require('./views/links/marketplace-links');
var getUserLinks = require('./views/links/user-links');

// Get List Items
var getManageListItems = require('./views/list-items/manage-list-items');
var getMarketplaceListItems = require('./views/list-items/marketplace-list-items');
var getUserListItems = require('./views/list-items/user-list-items');

// Get Lists
var getRenderList = require('./views/all-lists');

// Get Dropdowns
var getRenderDropdowns = require('./views/all-dropdowns');
var dropdownClickFunction = require('./templates/functions/dropdown-click-function.tpl');

var UniversalSearchBox = require('./views/appwise-search');
var IconsLink = require('./views/IconItems');

var MyAppsList = require('./views/list-items/myapps-items');

// Old partials that need to be refactored, but are currently still in use in some early migrations.
var companyDropdown = require('../deprecated/views/company-dropdown'); // Deprecated

function getData(deps) {
	var userData = getUserData.getUserData(deps);
	var marketplaceData = getMarketplaceData.getMarketplaceData(deps);
	var manageData = getManageData.getManageData(deps);
	var manageLinks = getManageLinks.renderManageLinks(deps);
	var marketplaceLinks = getMarketplaceLinks.renderMarketplaceLinks(deps);
	var userLinks = getUserLinks.renderUserLinks(deps);
	var manageListItems = getManageListItems.renderManageListItems(deps);
	var marketplaceListItems = getMarketplaceListItems.renderMarketplaceListItems(deps);
	var userListItems = getUserListItems.renderUserListItems(deps);
	var renderList = getRenderList.getRenderList(deps);
	var renderDropdown = getRenderDropdowns.getRenderDropdowns(deps);

	return {

		// AD MANAGE Components
		// -------------------------------------------------------
		MANAGE_LIST: renderList.renderManageList,
		MANAGE_DROPDOWN: renderDropdown.renderManageDropdown,

		ACCOUNT_HREF: manageData.getAccountUrl,
		ACCOUNT_LINK: manageLinks.renderAccountLink,
		ACCOUNT_LI: manageListItems.renderAccountListItem,

		CHANNEL_HREF: manageData.getChannelUrl,
		CHANNEL_LINK: manageLinks.renderChannelLink,
		CHANNEL_LI: manageListItems.renderChannelListItem,

		CORPORATE_HREF: manageData.getCorporateUrl,
		CORPORATE_LINK: manageLinks.renderCorporateLink,
		CORPORATE_LI: manageListItems.renderCorporateListItem,

		DEVELOPER_HREF: manageData.getDeveloperUrl,
		DEVELOPER_LINK: manageLinks.renderDeveloperLink,
		DEVELOPER_LI: manageListItems.renderDeveloperListItem,

		RESELLER_HREF: manageData.getResellerUrl,
		RESELLER_LINK: manageLinks.renderResellerLink,
		RESELLER_LI: manageListItems.renderResellerListItem,

		SUPERUSER_HREF: manageData.getSuperUserUrl,
		SUPERUSER_LINK: manageLinks.renderSuperuserLink,
		SUPERUSER_LI: manageListItems.renderSuperuserListItem,

		// AD MARKETPLACE Components
		// -------------------------------------------------------
		HOME_HREF: marketplaceData.getHomeUrl,
		HOME_LINK: marketplaceLinks.renderHomeLink,
		HOME_LI: marketplaceListItems.renderHomeListItem,

		LOGIN_HREF: marketplaceData.getLogInUrl,
		LOGIN_LINK: marketplaceLinks.renderLogInLink,
		LOGIN_LI: marketplaceListItems.renderLogInListItem,

		LOGOUT_HREF: marketplaceData.getLogOutUrl,
		LOGOUT_LINK: marketplaceLinks.renderLogOutLink,
		LOGOUT_LI: marketplaceListItems.renderLogOutListItem,

		MYAPPS_HREF: marketplaceData.getMyAppsUrl,
		MYAPPS_LINK: marketplaceLinks.renderMyAppsLink,
		MYAPPS_LI: marketplaceListItems.renderMyAppsListItem,

		MARKETPLACE_HREF: marketplaceData.getMarketplaceUrl,

		SIGNUP_HREF: marketplaceData.getSignUpUrl,
		SIGNUP_LINK: marketplaceLinks.renderSignUpLink,
		SIGNUP_LI: marketplaceListItems.renderSignUpListItem,

		CURRENT_LANGUAGE: marketplaceData.getCurrentLanguage,
		CURRENT_LANGUAGE_TAG: marketplaceData.getCurrentLanguageTag,

		LANGUAGE_LINKS: renderList.renderLanguageList,
		LANGUAGE_SELECT: renderList.renderLanguageSelect,
		LANGUAGE_DROPDOWN: renderDropdown.renderLanguageDropdown,

		COPYRIGHT_YEAR: marketplaceData.getCopyrightYear,

		PRIVACY_POLICY_URL: marketplaceData.getPrivacyPolicyUrl,

		// Channel Settings Support
		SUPPORT_URL: marketplaceData.getSupportUrl,

		SUPPORT_EMAIL: marketplaceData.getSupportEmail,

		SUPPORT_PHONE: marketplaceData.getSupportPhone,

		SUPPORT_CONTACT_URL: marketplaceData.getSupportContactUrl,

		// Channel Settings Legal
		TERMS_URL: marketplaceData.getTermsUrl,

		// AD USER Components
		// -------------------------------------------------------
		USER_LIST: renderList.renderUserList,
		USER_DROPDOWN: renderDropdown.renderProfileDropdown,

		SUBSCRIPTION_HREF: userData.getSubscriptionUrl,
		SUBSCRIPTION_LINK: userLinks.renderSubscriptionLink,
		SUBSCRIPTION_LI: userListItems.renderSubscriptionListItem,

		COMPANY_HREF: userData.getCompanyUrl,
		COMPANY_LINK: userLinks.renderCompanyLink,
		COMPANY_LI: userListItems.renderCompanyListItem,

		PROFILE_HREF: userData.getProfileUrl,
		PROFILE_LINK: userLinks.renderProfileLink,
		PROFILE_LI: userListItems.renderProfileListItem,

		SETTINGS_HREF: userData.getSettingsUrl,
		SETTINGS_LINK: userLinks.renderSettingsLink,
		SETTINGS_LI: userListItems.renderSettingsListItem,

		MOBILE_SWITCH_HREF: userData.getMobileSwitchUrl,
		MOBILE_SWITCH_LINK: userLinks.renderMobileSwitchLink,
		MOBILE_SWITCH_LI: userListItems.renderMobileSwitchListItem,

		USER_EMAIL: userData.getUserEmail,

		USER_NAME: userData.getUserName,
		USER_FIRSTNAME: userData.getUserFirstName,
		USER_IMG: userData.getUserImg,
		SEARCH_BOX: new UniversalSearchBox().render,
		MYAPPS_DROPDOWN: new MyAppsList().render,
		SEARCH_FORM: renderList.renderSearch,

		COMPANY_LIST: renderList.renderCompanyList,
		COMPANY_DROPDOWN: renderDropdown.renderCompanyDropdown,

		ICON_HOME: new IconsLink().renderHome,
		ICON_APPWISE: new IconsLink().renderAppWise,
		ICON_APPINSIGHT: new IconsLink().renderAppInsight,
		ICON_MARKETPLACE: new IconsLink().renderMarketplace,
		ICON_USER_IMG: new IconsLink().renderUserImg,

		CURRENCY_DROPDOWN: renderDropdown.renderCurrencyDropdown,

		JS_DROPDOWN_CLICK: function() {
			return dropdownClickFunction;
		},

		// Universal Header React Components
		// intentionally blank strings
		// -------------------------------------------------------
		'MPLOGO-COMPONENT': '',
		'MYAPPS-DROPDOWN-COMPONENT': '',
		'ICON-HOME-COMPONENT': '',
		'ICON-APPWISE-COMPONENT': '',
		'ICON-APPINSIGHT-COMPONENT': '',
		'ICON-MARKETPLACE-COMPONENT': '',

		// -------------------------------------------------------
		// DEPRECATED
		// (use only the components above)
		// -------------------------------------------------------
		MANAGE_LINKS: renderList.renderManageLinksOld,

		COMPANIES_DROPDOWN: function(config) {
			return companyDropdown.render(config.UserInfo, config.memberships, deps);
		}
	};
}

module.exports = {
	getData: getData
};



//////////////////
// WEBPACK FOOTER
// ./~/ad-theme-customizer-client/src/components/components.js
// module id = 4
// module chunks = 0